import {User} from '@entities/user';
import {v8nSchemaOfGetUsersResponse} from '@entities/user/api/backendSchemas';
import {GetUsersResponse} from '@entities/user/api/backendTypes';
import {mapUserFromBackend} from '@entities/user/api/dataMappers';
import {axi, GetListOutput, GetListParams} from '@shared/api';
import {validateData} from '@shared/utils';
import {ReferralProgress} from '../types';
import {referralProgressV8nSchema} from './backendSchemas';
import {ReferralProgressOnBackend} from './backendTypes';
import {mapReferralProgressFromBackend} from './dataMappers';

export type GetReferralsParams = GetListParams & {userId?: string};

export const getReferrals = async ({
  userId,
  page,
  pageSize,
}: GetReferralsParams = {}): Promise<GetListOutput<User>> => {
  const path = userId
    ? `/admin/users/${userId}/referrals`
    : '/admin/users/referrals';
  const {data} = await axi.get<GetUsersResponse>(path, {
    params: {page, per_page: pageSize},
  });

  validateData(data, v8nSchemaOfGetUsersResponse, 'getReferrals');

  return {
    page: data.page,
    pageSize: data.per_page,
    total: data.total,
    totalPages: data.total_pages,
    items: data.array.map(item => mapUserFromBackend(item)),
  };
};

export const getReferralProgress = async (
  userId: string,
): Promise<ReferralProgress> => {
  const {data} = await axi.get<ReferralProgressOnBackend>(
    `/admin/users/${userId}/referrals/progress`,
  );
  validateData(data, referralProgressV8nSchema, 'getReferralProgress');
  return mapReferralProgressFromBackend(data);
};
